import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

const version = 'v1';

export function useFuncionalidadeService() {
  const { backendGet } = Sebrae.useBackend();

  const getObterFuncionalidades = React.useCallback(
    () => backendGet(`${version}/funcionalidades`),
    [backendGet],
  );

  const getObterFuncionalidadesAtivas = React.useCallback(
    () => backendGet(`${version}/funcionalidades/ativas`),
    [backendGet],
  );

  return {
    getObterFuncionalidades,
    getObterFuncionalidadesAtivas,
  };
}
